import { present, runValidations } from '../base.validations';

const attributeValidators = {
  text: [{ validation: present }]
}

export function paragraphValidations(paragraph) {
  return runValidations(paragraph, attributeValidators);
}
